
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartCautionaryNotes as ObiChartCautionaryNotesElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-cautionary-notes.js';
 
 
 

 
 export const ObiChartCautionaryNotes = createComponent({
   react: React,
   tagName: 'obi-chart-cautionary-notes',
   elementClass: ObiChartCautionaryNotesElement,
   events: {
     
   }
  });
 
 